export enum ArticleTagRouteName {
    Index = 'system.article.tags.index',
    Create = 'system.article.tags.create',
    Edit = 'system.article.tags.edit',
}

export default {
    path: 'article-tags',
    name: ArticleTagRouteName.Index,
    component: () => import('@/views/system/article-tag/Index.vue'),
    meta: {
        auth: true,
        label: 'Article Tags',
        icon: 'fal fa-folder-tree fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-categories',
    },
    children: [
        {
            path: 'create',
            name: ArticleTagRouteName.Create,
            component: () => import('@/views/system/article-tag/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Tag',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-categories',
            },
        },
        {
            path: ':categoryUuid/edit',
            name: ArticleTagRouteName.Edit,
            component: () => import('@/views/system/article-tag/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Tag',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-categories',
            },
        },
    ],
}
